import { render } from "./GifTableDash.vue?vue&type=template&id=030a1d65"
import script from "./GifTableDash.vue?vue&type=script&lang=js"
export * from "./GifTableDash.vue?vue&type=script&lang=js"

import "./GifTableDash.vue?vue&type=style&index=0&id=030a1d65&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__